import { c as _c } from "react/compiler-runtime";
import { type FocusEventHandler, startTransition, useEffect, useState } from "react";
import { usePrev } from "~/client/hooks";
import { isEqual } from "~/shared/utils";
import { makeInputError } from "./helpers";
import type { BaseInputDependencies, BaseInputProps } from "./Input.d";

/**
 * @function useInput
 * @param {BaseInputDependencies}
 * @returns {BaseInputProps}
 */
export const useInput = t0 => {
  const $ = _c(41);
  let dataId;
  let onBlur;
  let onFocus;
  let props;
  let serverError;
  let validate;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      validate,
      serverError,
      onBlur,
      onFocus,
      "data-testid": dataId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = dataId;
    $[2] = onBlur;
    $[3] = onFocus;
    $[4] = props;
    $[5] = serverError;
    $[6] = validate;
    $[7] = value;
  } else {
    dataId = $[1];
    onBlur = $[2];
    onFocus = $[3];
    props = $[4];
    serverError = $[5];
    validate = $[6];
    value = $[7];
  }
  const errorSource = makeInputError({
    "data-testid": dataId,
    value,
    validate,
    serverError
  });
  const prevServerError = usePrev(serverError);
  const [error, setError] = useState(null);
  const isServerError = isEqual(serverError?.message, errorSource);
  let t1;
  if ($[8] !== errorSource || $[9] !== isServerError || $[10] !== onBlur || $[11] !== setError) {
    t1 = e => {
      onBlur?.(e);
      setError(isServerError ? null : errorSource);
    };
    $[8] = errorSource;
    $[9] = isServerError;
    $[10] = onBlur;
    $[11] = setError;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  const handleBlur = t1;
  let t2;
  if ($[13] !== onFocus || $[14] !== setError) {
    t2 = e_0 => {
      startTransition(() => {
        onFocus?.(e_0);
        setError(null);
      });
    };
    $[13] = onFocus;
    $[14] = setError;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const handleFocus = t2;
  let t3;
  if ($[16] !== errorSource || $[17] !== isServerError || $[18] !== setError || $[19] !== value) {
    t3 = () => {
      if (value && !isServerError) {
        setError(errorSource);
      }
    };
    $[16] = errorSource;
    $[17] = isServerError;
    $[18] = setError;
    $[19] = value;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== errorSource || $[22] !== isServerError || $[23] !== value) {
    t4 = [errorSource, isServerError, value];
    $[21] = errorSource;
    $[22] = isServerError;
    $[23] = value;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  useEffect(t3, t4);
  let t5;
  if ($[25] !== errorSource || $[26] !== prevServerError || $[27] !== serverError || $[28] !== setError || $[29] !== value) {
    t5 = () => {
      const serverErrorChanged = !isEqual(prevServerError, serverError);
      if (value && serverErrorChanged) {
        setError(errorSource);
      }
    };
    $[25] = errorSource;
    $[26] = prevServerError;
    $[27] = serverError;
    $[28] = setError;
    $[29] = value;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] !== errorSource || $[32] !== prevServerError || $[33] !== serverError || $[34] !== value) {
    t6 = [errorSource, prevServerError, serverError, value];
    $[31] = errorSource;
    $[32] = prevServerError;
    $[33] = serverError;
    $[34] = value;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  useEffect(t5, t6);
  let t7;
  if ($[36] !== error || $[37] !== handleBlur || $[38] !== handleFocus || $[39] !== props) {
    t7 = {
      ...props,
      error,
      onBlur: handleBlur,
      onFocus: handleFocus
    };
    $[36] = error;
    $[37] = handleBlur;
    $[38] = handleFocus;
    $[39] = props;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  return t7;
};